import { render, staticRenderFns } from "./PriceMatchPromoCode.vue?vue&type=template&id=07805650&"
import script from "./PriceMatchPromoCode.vue?vue&type=script&lang=js&"
export * from "./PriceMatchPromoCode.vue?vue&type=script&lang=js&"
import style0 from "./PriceMatchPromoCode.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports